import { Group, HStack, Spacer } from '@chakra-ui/react'
import type { FC } from 'react'

import SharingIcon from './sharingIcon'
import StrategyDeleteButton from './strategyDeleteButton'

import MapCloneButton from '@app/pages/strategies/components/mapCloneButton'
import Can from '@app/shared/authorization/can'
import FavoriteToggleButton from '@app/shared/favorites/favoriteToggleButton'
import type { DomainStrategy } from '@app/types'

interface Props {
  strategy: DomainStrategy
}

const StrategyListActions: FC<Props> = ({ strategy }) => {
  const { id, favoriteId, sharing } = strategy

  return (
    <HStack>
      <Spacer />
      <Group attached>
        <Spacer />
        <FavoriteToggleButton favoritableType="Strategy" favoritableId={id} favoriteId={favoriteId} />
        <Can I="update" a="strategy">
          <SharingIcon sharing={sharing} />
          <MapCloneButton strategyId={strategy.id} />
          <StrategyDeleteButton strategyId={strategy.id} />
        </Can>
      </Group>
    </HStack>
  )
}

export default StrategyListActions
